import { createContext, type ReactNode, useContext } from "react";
import { createPortal } from "react-dom";

/** The app bar's right edge. Every screen puts its add and import actions here, so they never move. */
export const PageActionsSlot = createContext<HTMLElement | null>(null);

export function PageActions({ children }: { children: ReactNode }) {
  const slot = useContext(PageActionsSlot);
  return slot ? createPortal(children, slot) : null;
}
